type Callback = () => void;

export type Composable = {
  isReady: () => Promise<void>;
};

export default async (
  composables: (Composable | undefined)[],
  callback: Callback,
) => {
  const promises: Promise<void>[] = composables
    .filter((item) => item !== undefined)
    .map((composable) => composable.isReady());

  await Promise.all(promises);
  callback();
};
